// extracted by mini-css-extract-plugin
var _1 = "_goldConversion-module__title";
export { _1 as "title" }
